import React, { useEffect, useState } from 'react';
import { Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import PageHeaderText from 'components/base/page-header-text';
import { apiService } from 'services/base.service';
import SingleBottomNav from 'components/base/single-bottom-nav';
import { useParams } from 'react-router-dom';
import SelectionType from 'components/selection-type';

type formData = {
  name: string;
  summary: string;
  description: string;
  images: string[];
  icon: string;
  selection_no: string;
  min_selection_no: string;
  position: 0;
  meal_category_selection_type_id: string;
};

const EditBaseAddonCategory = () => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [formData, setFormData] = useState({
    position: 0
  } as formData);

  const onConfirm = async () => {
    setLoading(true);
    try {
      const payload: any = { ...formData };
      payload.min_selection_no = Number(payload.min_selection_no);
      delete payload.images;

      const res = await apiService.put(`base-addon-category/${id}`, {
        data: payload,
        isInternal: true
      });
      if (res.data) {
        toast(<ToastMessage type='success' message={'Base addon category updated successfully'} />);
      }
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };
  const getDetails = async () => {
    try {
      const res = await apiService.get(`base-addon-category/${id}`, {
        isInternal: true
      });
      if (res.data) {
        setFormData(res.data.data);
      }
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error?.response?.data?.message} />);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  return (
    <div>
      <PageHeaderText
        title='Edit Base Add-on Category'
        description='Ensure you provide correct details'
      />
      {formData.name ? (
        <div className='w-[48em]'>
          <Input
            small
            label='Addon category name'
            type='text'
            placeholder='Addon category name'
            className='mt-8 text-sm'
            inputClass='px-[20px] py-[14px]'
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <Input
            small
            label='Addon category description'
            type='text'
            placeholder='Addon category description'
            className='my-6 text-sm'
            inputClass='px-[20px] py-[14px]'
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          />
          <SelectionType
            selectionType={formData.meal_category_selection_type_id}
            setSelectionType={(e) =>
              setFormData({ ...formData, meal_category_selection_type_id: e })
            }
          />

          <Input
            small
            label='Min Selection'
            type='tel'
            placeholder='Select number'
            className=' text-sm'
            inputClass='px-[20px] py-[14px]'
            value={formData.min_selection_no}
            onChange={(e) => setFormData({ ...formData, min_selection_no: e.target.value })}
          />
          <Input
            small
            label='Max selection'
            type='tel'
            placeholder='Enter number'
            className='mt-5 text-sm'
            inputClass='px-[20px] py-[14px]'
            value={formData.selection_no}
            onChange={(e) => setFormData({ ...formData, selection_no: e.target.value })}
          />
          <SingleBottomNav onConfirm={onConfirm} btnDisabled={!formData?.name} loading={loading} />
        </div>
      ) : (
        <div className='flex justify-center '>
          <p className='mt-10'>No addon category found</p>
        </div>
      )}
    </div>
  );
};

export default EditBaseAddonCategory;
